import i18n from '../../utils/i18n';

export const BOM_TABLE_COLS = [
	{
		key: 'part',
		numeric: false,
		sortable: true,
		label: i18n.t('bomTable.part'),
		unit: '',
		pdfExport: true
	},
	{
		key: 'manufacturer',
		numeric: false,
		sortable: true,
		label: i18n.t('bomTable.manufacturer'),
		unit: '',
		pdfExport: true
	},
	{
		key: 'partNumber',
		numeric: false,
		sortable: true,
		label: i18n.t('bomTable.partNumber'),
		unit: '',
		pdfExport: true
	},
	{
		key: 'quantity',
		numeric: true,
		sortable: true,
		label: i18n.t('bomTable.quantity'),
		unit: '',
		pdfExport: true
	},
	{
		key: 'totalPriceFormatted',
		numeric: true,
		sortable: true,
		label: i18n.t('bomTable.totalPrice'),
		unit: '[$|1ku]',
		pdfExport: true
	},
	{
		key: 'attributes',
		numeric: false,
		sortable: false,
		label: i18n.t('bomTable.attributes'),
		unit: '',
		pdfExport: true
	},
	{
		key: 'totalFootprint',
		numeric: true,
		sortable: true,
		label: i18n.t('bomTable.totalFootprint'),
		unit: '[mm\u00b2]',
		pdfExport: true
	},
	{
		key: 'description',
		numeric: false,
		sortable: false,
		label: i18n.t('bomTable.description'),
		unit: '',
		pdfExport: false
	}
];

export const BOM_ATTRIBUTES = {
	/* IC */
	MinOrder: 'Min. order',
	/* Inductor */
	Inductance: 'L',
	InductorDCResistance: 'Rdc',
	InductorHeight: 'Height',
	/* Capacitor */
	Capacitance: 'C',
	CapacitorDCvoltage: 'Vdc',
	CapacitorImpedanceESR: 'ESR',
	CapacitorImpedanceESR_SRF: 'ESR',
	CapacitorImpedanceESR_10KHz: 'ESR(10 KHz)',
	CapacitorImpedanceESR_100KHz: 'ESR(100 KHz)',
	CapacitorDiameter: 'Diameter',
	CapacitorHeight: 'Height',
	/* Resistor */
	Resistance: 'R',
	Tolerance: 'tol',
	MaxWorkingVoltage: 'Vmax',
	MaxPowerDissipation: 'Pmax',
	ResistorHeight: 'Height',
	/* FET */
	RdsonVgs10V: 'Rdson(Vgs=10 V)',
	IdTa25C: 'Id(Ta=25 C)',
	/* Diode */
	IfwAvg: 'Ifw(avg)',
	VfwMax: 'Vfw(max)'
};

export const BOM_COMPONENTS = {
	U1: {
		index: 0,
		label: 'IC<sub>CV/CT</sub>'
	},
	ICiso: {
		index: 1,
		label: 'IC<sub>ISO</sub>'
	},
	IC: {
		index: 2,
		label: 'IC'
	},
	HS: {
		index: 3,
		label: 'Q<sub>HS</sub>'
	},
	LS: {
		index: 4,
		label: 'Q<sub>LS</sub>'
	},
	Q: {
		index: 5,
		label: 'Q'
	},
	Q1: {
		index: 6,
		label: 'Q<sub>1</sub>'
	},
	Q2: {
		index: 7,
		label: 'Q<sub>2</sub>'
	},
	D: {
		index: 8,
		label: 'D'
	},
	Dout: {
		index: 9,
		label: 'D<sub>OUT</sub>'
	},
	Dsn: {
		index: 10,
		label: 'D<sub>SN</sub>'
	},
	D1: {
		index: 11,
		label: 'D<sub>1</sub>'
	},
	D2: {
		index: 12,
		label: 'D<sub>2</sub>'
	},
	D3: {
		index: 13,
		label: 'D<sub>3</sub>'
	},
	D4: {
		index: 14,
		label: 'D<sub>4</sub>'
	},
	Lout: {
		index: 15,
		label: 'L<sub>OUT</sub>'
	},
	Cbias: {
		index: 16,
		label: 'C<sub>BIAS</sub>'
	},
	Cin: {
		index: 17,
		label: 'C<sub>IN</sub>'
	},
	Cout: {
		index: 18,
		label: 'C<sub>OUT</sub>'
	},
	Cdc: {
		index: 19,
		label: 'C<sub>DC</sub>'
	},
	Cff: {
		index: 20,
		label: 'C<sub>FF</sub>'
	},
	C1: {
		index: 21,
		label: 'C<sub>1</sub>'
	},
	C2: {
		index: 22,
		label: 'C<sub>2</sub>'
	},
	C3: {
		index: 23,
		label: 'C<sub>3</sub>'
	},
	C4: {
		index: 24,
		label: 'C<sub>4</sub>'
	},
	C5: {
		index: 25,
		label: 'C<sub>4</sub>'
	},
	Rs: {
		index: 26,
		label: 'R<sub>S</sub>'
	},
	Rbot: {
		index: 27,
		label: 'R<sub>BOT</sub>'
	},
	Rtop: {
		index: 28,
		label: 'R<sub>TOP</sub>'
	},
	T: {
		index: 29,
		label: 'T'
	},
	Csn: {
		index: 30,
		label: 'C<sub>SN</sub>'
	},
	Rsn: {
		index: 31,
		label: 'R<sub>SN</sub>'
	},
	RS: {
		index: 32,
		label: 'R<sub>S</sub>'
	}
};

export const BOM_CSV_HEADER = [
	{ label: i18n.t('bomTable.part'), key: 'part' },
	{ label: i18n.t('bomTable.manufacturer'), key: 'manufacturer' },
	{ label: i18n.t('bomTable.partNumber'), key: 'partNumber' },
	{ label: i18n.t('bomTable.quantity'), key: 'quantity' },
	{ label: `${i18n.t('bomTable.totalPrice')} [$]`, key: 'totalPriceFormatted' },
	{ label: i18n.t('bomTable.attributes'), key: 'attributes' },
	{ label: `${i18n.t('bomTable.totalFootprint')}  [mm\u00b2]`, key: 'totalFootprint' },
	{ label: i18n.t('bomTable.description'), key: 'description' }
];
